exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".procedure-check[data-v-30c917a0] {\n  cursor: pointer;\n}", ""]);

// exports
